import type { CollectionReference, DocumentData } from 'firebase/firestore'
import {
  collection,
  doc,
  serverTimestamp,
  type Firestore,
  type FirestoreDataConverter,
  type QueryDocumentSnapshot,
} from 'firebase/firestore'
import { modelItemStream, modelListStream } from '../../firestore-mobx/stream'
import type { FirebaseRepository } from '../../models/FirebaseRepository'
import { buildUnsupportedConverter } from '../shared/noops'
import type { FirestorePromptRoomStateType } from './schema'
import { schema } from './schema'

import { type RoomStatePromptType } from './types'
import { updateDocWithError } from '../../firestore-mobx/fetch'
import { PromptRoomStateType } from '../../models/PromptRoomStateType'

export * from './schema'

const unsupported = buildUnsupportedConverter<FirestorePromptRoomStateType>()

const readConverter: FirestoreDataConverter<FirestorePromptRoomStateType> = {
  toFirestore: unsupported.toFirestore,
  fromFirestore: (snapshot: QueryDocumentSnapshot) => {
    const data = snapshot.data({ serverTimestamps: 'estimate' })
    return schema.parse(data)
  },
}

const getReadCollectionRef = (
  firestore: Firestore
): CollectionReference<FirestorePromptRoomStateType, DocumentData> => {
  return collection(
    firestore,
    'prompt',
    'room_state_prompt',
    'type'
  ).withConverter(readConverter)
}

export const getPromptRoomStateTypes = (repository: FirebaseRepository) => {
  const ref = getReadCollectionRef(repository.firestore)
  return modelListStream(repository, ref, PromptRoomStateType)
}

export const getPromptRoomStateType = (
  repository: FirebaseRepository,
  { type }: { type: RoomStatePromptType }
) => {
  const col = getReadCollectionRef(repository.firestore)
  const docRef = doc(col, type)
  return modelItemStream(repository, docRef, PromptRoomStateType)
}

export const updatePromptRoomStateType = async (
  repository: FirebaseRepository,
  {
    title,
    description,
    roomStateType,
  }: Pick<FirestorePromptRoomStateType, 'title' | 'description'> & {
    roomStateType: RoomStatePromptType
  }
) => {
  const ref = getReadCollectionRef(repository.firestore)
  const docRef = doc(ref, roomStateType).withConverter(null)
  return await updateDocWithError(
    docRef,
    {
      title,
      description,
      updatedAt: serverTimestamp(),
    },
    'UpdatePromptRoomStateTypeError'
  )
}
